import {
  LISTING_EDIT_RESTRICTED_DAYS,
  RESTRICTED_STATUSES,
  RestrictedStatusType,
} from './types';

/**
 * Checks if a listing status string contains any of the restricted (off-market) statuses.
 * The check is case-insensitive by converting the status to uppercase.
 */
export const isRestrictedStatus = (listingStatus: string): boolean => {
  if (!listingStatus || listingStatus.length === 0) return false;

  const statuses = Object.values(RESTRICTED_STATUSES);
  return statuses.some((status: RestrictedStatusType) =>
    listingStatus.toUpperCase().includes(status),
  );
};

/**
 * Parses a string or a Date object into a numeric timestamp (milliseconds since epoch).
 */
export const parseToTimestamp = (input: string | Date): number | null => {
  if (input instanceof Date) {
    return isNaN(input.getTime()) ? null : input.getTime();
  }

  if (typeof input === 'string') {
    const timestamp = Date.parse(input);
    return isNaN(timestamp) ? null : timestamp;
  }

  return null;
};

export const checkEditRestrictedOffMarket = (
  listingStatus: string,
  baseOffMarketDate: string | Date,
): boolean => {
  if (!isRestrictedStatus(listingStatus)) {
    return false; // Not a restricted status, so no edit restriction applies.
  }

  const listingBaseOffMarketDate = parseToTimestamp(baseOffMarketDate);
  if (listingBaseOffMarketDate === null) {
    // Assuming for now an invalid date means the check fails (no restriction).
    return false;
  }

  // This is an off market listing. Check to see if it's been off market for more than
  // the number of restricted edit days
  const maxRestrictedEditUTCDate = new Date();
  maxRestrictedEditUTCDate.setUTCDate(
    maxRestrictedEditUTCDate.getUTCDate() - LISTING_EDIT_RESTRICTED_DAYS,
  );

  const cutoffTimestamp = maxRestrictedEditUTCDate.getTime();
  const isListingEditRestricted = listingBaseOffMarketDate < cutoffTimestamp;

  return isListingEditRestricted;
};
